import BusinessCell from './container';

export default BusinessCell;
